// extracted by mini-css-extract-plugin
export default {"overlay":"tooltip_overlay__RSVLa"};